import React, { Fragment, lazy, Suspense, useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from 'redux/storeConfig/store'
import { useSelector } from 'react-redux'
// ** International Language
import { IntlProviderWrapper } from './utils/context/Internationalization'
// styles
import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "assets/demo/demo.css?v=1.3.0";
import Loader from "react-loader-spinner";
import Router from "router/Router";
import { ConfigProvider } from 'utils/context/ConfigContext'
// EMC Tracking Code

const EMCTracking = () => {
  useEffect(() => {
    // Đảm bảo biến toàn cục window._govaq được khởi tạo và giữ nguyên
    window._govaq = window._govaq || [];
    window._govaq.push(['setTrackerUrl', 'https://f-emc.ngsp.gov.vn/tracking']);
    window._govaq.push(['setSiteId', '4139']);
    window._govaq.push(['enableLinkTracking']);
    window._govaq.push(['trackPageView']);

    // Tải script sau đó
    const script = document.createElement('script');
    script.src = 'https://f-emc.ngsp.gov.vn/embed/gov-tracking.min.js';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }, []);

  return null;
};

export default EMCTracking;

// ** Lazy load app
const LazyApp = lazy(() => import('./router/Router'))

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" />}>
    <BrowserRouter> {/* ✅ Bọc Router để các hook như useLocation hoạt động */}
      <ConfigProvider>
      <IntlProviderWrapper>
        {/* EMC Tracking */}
        <EMCTracking />
        <LazyApp />
      </IntlProviderWrapper>
      </ConfigProvider>
      </BrowserRouter>

    </Suspense>
  </Provider>,
  document.getElementById("root")
  
);
